var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortAmountDesc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.46,11.613V0H3.478V11.613H1L4.469,15l3.469-3.387Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,0h8.919V1.982H14Z",
    transform: "translate(-6.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,6h6.937V7.982H14Z",
    transform: "translate(-6.919 -3.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,12h4.955v1.982H14Z",
    transform: "translate(-6.782 -6.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,18h2.973v1.982H14Z",
    transform: "translate(-6.746 -9.321)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAmountDesc);
export default __webpack_public_path__ + "static/media/sort-amount-desc.da619106.svg";
export { ForwardRef as ReactComponent };